function n(e, i) {
  e.timeline = i, e.onfinish = null;
}
export {
  n as attachTimeline
};
